/**
 * @Description 商圈详情小天才-评分组件
 */

import { beautifyTheLowHighObject, isNotEmpty } from '@lhb/func';

export enum XTCScoreType {
  XTC = 1, // 小天才
  BBG = 2, // 步步高
};

// 时间维度 1:天 2:周 3:月 4:季 5:年
enum TimeDimension {
  Day = 1, // 审批中
  Week,
  Month,
  Season,
  Year,
};
export const TimeDimensionMap = new Map([
  [TimeDimension.Day, '天'],
  [TimeDimension.Week, '周'],
  [TimeDimension.Month, '月'],
  [TimeDimension.Season, '季'],
  [TimeDimension.Year, '年'],
]);

/**
 * @description 格式化预测营业额相关数据
 * @param data
 * @returns {val, unit, title}
 */
export const formatPredictSale = (timeDimension: any, salesAmountPredict: number) => {
  const title = `预测${TimeDimensionMap.get(timeDimension) || ''}营业额`;
  const canShowValue = isNotEmpty(salesAmountPredict);
  if (canShowValue) {
    const res = beautifyTheLowHighObject(1, salesAmountPredict, 2, { low: '元', high: '万元', top: '亿元' });
    return {
      title,
      val: res.val,
      unit: res.unit
    };
  }
  return {
    val: '',
    unit: '',
    title,
  };
};
